import api from './api';

// ─── Rules (report_category_map) ───
export const getFlexibleRules = () => api.get('/flexible-reports/rules').then(r => r.data);
export const upsertFlexibleRule = (data) => api.post('/flexible-reports/rules', data).then(r => r.data);
export const deleteFlexibleRule = (id) => api.delete(`/flexible-reports/rules/${id}`).then(r => r.data);

// ─── Adjustments (per-tx overrides) ───
export const getFlexibleAdjustments = (versionId) =>
  api.get(`/flexible-reports/adjustments${versionId && versionId !== 'working' ? `?version_id=${versionId}` : ''}`).then(r => r.data);

export const upsertFlexibleAdjustment = (txId, data) =>
  api.put(`/flexible-reports/adjustments/${txId}`, data).then(r => r.data);

export const clearFlexibleAdjustment = (txId) =>
  api.put(`/flexible-reports/adjustments/${txId}`, { clear: true }).then(r => r.data);

// ─── Monthly Report ───
export const getFlexibleReport = (month, versionId) => {
  const params = new URLSearchParams({ month });
  if (versionId && versionId !== 'working') params.set('version_id', versionId);
  return api.get(`/flexible-reports/report?${params}`).then(r => r.data);
};

// ─── Aggregate (compare) ───
export const getFlexibleAggregate = (fromMonth, toMonth, versionId) => {
  const params = new URLSearchParams({ from_month: fromMonth, to_month: toMonth });
  if (versionId && versionId !== 'working') params.set('version_id', versionId);
  return api.get(`/flexible-reports/aggregate?${params}`).then(r => r.data);
};

// ─── Export ───
export const downloadFlexibleExport = async (format, month, versionId) => {
  const params = new URLSearchParams({ month });
  if (versionId && versionId !== 'working') params.set('version_id', versionId);
  const r = await api.get(`/flexible-reports/export/${format}?${params}`, { responseType: 'blob' });
  const blob = new Blob([r.data], { type: format === 'csv' ? 'text/csv' : 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `flexible_report_${month}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// ─── Versions ───
export const getFlexibleVersions = () => api.get('/flexible-reports/versions').then(r => r.data);
export const createFlexibleVersion = (data) => api.post('/flexible-reports/versions', data).then(r => r.data);
export const deleteFlexibleVersion = (id) => api.delete(`/flexible-reports/versions/${id}`).then(r => r.data);

// ─── AI ───
export const aiClassifyFlexible = (month, transaction_ids = null) =>
  api.post('/flexible-reports/ai-classify', { month, transaction_ids }, { timeout: 60000 }).then(r => r.data);

export const aiParseFlexibleInstruction = (transaction_id, instruction) =>
  api.post('/flexible-reports/ai-parse-instruction', { transaction_id, instruction }).then(r => r.data);
